<div class="cls-app-panel" [ngStyle]=_styleStr class={{classSrt}}>
  <ng-content></ng-content>
</div>
